import { gql } from '@apollo/client';

export const FETCH_PAYMENT_CONSENT = gql`
  query Flex_FetchPaymentConsent($internalName: [String!]) {
    currentContractVersions(contractType: consent, internalName: $internalName) {
      id
      displayName
      internalName
      contractType
      notes
      fileUrl
    }
  }
`;
